export default () => {
  const styleD = [
    'background: #000',
    'color: white',
    'padding: 5px 20px',
    'font-weight: 400',
    'line-height: 15px',
  ].join(';');
  /* eslint-disable-next-line no-console */
  console.log('%c🤔💭 2b || !2b', styleD);

  const style = [
    'background: #d33d27',
    'color: white',
    'padding: 5px 20px',
    'font-weight: 700',
    'line-height: 25px',
  ].join(';');
  /* eslint-disable-next-line no-console */
  console.log('%cAntmoves | Explore more projects @ antmoves.com', style);
};
